const es = {
  login: {
    title: "Sistema de envío de datos",
    email: "Correo electrónico",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    logout: "Cerrar sesión",
    inEmail: "Correo electrónico no válido",
    loginfailed:
      "Error al iniciar sesión, correo electrónico o contraseña incorrectos",
    enterEmail: "Ingresa tu correo electrónico",
    enterPassword: "Ingresa tu contraseña",
    enterCode: "Ingresa el código de verificación",
    passwordNotMatch: "Las contraseñas no coinciden",
  },
  forgot: {
    forgotPassword: "Contraseña olvidada",
    tip: "Te enviaremos un código de verificación a tu dirección de correo electrónico",
    email: "Correo electrónico",
    code: "Código de verificación",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    send: "Enviar",
    submit: "Enviar",
    login: "Iniciar sesión",
  },
  menu: {
    mange: "Gestión de formularios",
    mangeTip:
      "Creación de formularios de envío de datos, visualización de datos",
    submission: "Completar formulario",
    account: "Gestión de cuenta",
    uwell: "Cuenta interna",
    external: "Cuenta externa",
  },
  editList: {
    fill: "Completar",
    record: "Datos",
    createdTime: "Fecha de creación",
    formTitle: "Nombre del formulario",
    titleTip: "Ingresa un título",
    showInput: "Mostrar formularios para completar y registros de completados",
  },
  editFill: {
    save: "guardar",
    nosave:'No guardar',
    backSaveTip:'Desea guardar el contenido introducido?',
    submitted:'enviado',
    notsubmitted:'no enviado',

    submit: "Enviar",
    submitSuccess: "Envío realizado con éxito",
    fillAgain: "Completar nuevamente",
    invalid: "Parámetro no válido",
    noTime: "El formulario no está disponible en este momento",
    failedStop: "Error al enviar, el formulario ya no acepta más datos",
    failedNot: "Error al enviar, el formulario no existe",
    failedPassed:
      "Error al enviar, el formulario solo se puede completar una vez",
    failedOnce:
      "Error al enviar, el formulario solo se puede completar una vez al día",
    noempty: "Los campos obligatorios no pueden estar vacíos",
  },
  editInfo: {
    SubmitTime: "Fecha de envío",
    submitter:'Remitente',
    search: "Buscar",
    clear: "Limpiar",
    filter: "Filtrar",
    fieldSetting: "Gestión de campos",
    export: "Exportar",
    createBy: "Creado por",
    updateTime: "Fecha de actualización",
    status:'estado',
    action: "Acción",
    detail: "Detalles",
    edit: "Editar",
    more:"Más",
    copy:"Copiar",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    selectAll: "Seleccionar todo",
    confirm: "Confirmar",
    cancel: "Cancelar",
    addFilter: "Agregar criterio de filtrado",
    pleaseSelect: "Por favor selecciona",
    pleaseFillIn: "Por favor completa",
    delete: "Eliminar",
    filterIncom:
      "El criterio de filtrado de la fila {num} no está completo, por favor verifica",
    noData: "No hay datos disponibles",
    uploadfailed: "Error al cargar",
    total: "Total: {num} elementos",

    deleteTip: 'Esta operación eliminará los datos. ¿Desea continuar?',
    deleteSuccess: 'Eliminación exitosa'
  },
  fillIn: {
    equal: "Igual a",
    noequal: "Diferente de",
    contains: "Contiene",
    notcontains: "No contiene",
    empty: "Vacío",
    notempty: "No vacío",
    before: "Antes de",
    after: "Después de",
    greaterequal: "Mayor o igual que",
    lessequal: "Menor o igual que",
    greaterthan: "Mayor que",
    lessthan: "Menor que",
  },
  editEye: {
    detail: "Datos del formulario",
  },
  editUpdate: {
    editForm: "Modificar formulario",
    returnList: "Volver a la lista",
  },
};

export default es;